import { render, staticRenderFns } from "./TscIpAutoDistributePage.vue?vue&type=template&id=737a61bb&"
import script from "./TscIpAutoDistributePage.vue?vue&type=script&lang=js&"
export * from "./TscIpAutoDistributePage.vue?vue&type=script&lang=js&"
import style0 from "./TscIpAutoDistributePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports